import { createActions } from 'redux-actions';

import types from 'state/direct-order/insurance/actionTypes';

const { directOrder } = createActions({
  [types.setInsuranceFor$]: (insuranceQuantity) => ({ insuranceQuantity }),
  [types.SET_INSURANCE_QUANTITY]: (insuranceQuantity) => ({
    insuranceQuantity,
  }),
  [types.CLEAN_INSURANCE]: () => ({}),
});

export default directOrder;
